// AuthContext.js - Compatibility layer for mobile auth
import { createContext, useContext } from 'react';
import { MobileAuthContext } from './MobileAuthProvider';

// Create context (for existing imports)
export const AuthContext = createContext();

// Custom hook that provides the same interface as the original auth provider
export const useAuth = () => {
  // Check if we're in a mobile WebView environment
  const isWebView = !!window.ReactNativeWebView;

  // Always call hooks at the top level
  const contextAuth = useContext(AuthContext);
  const mobileAuth = useContext(MobileAuthContext);

  // In WebView environment, use mobile auth if available
  if (isWebView && mobileAuth) {
    return mobileAuth;
  }

  // Fallback to regular auth context
  return contextAuth;
};

export default AuthContext;
